import React from 'react';
import { ApiCacheProvider } from '../store/ApiCacheContext.jsx';
import { UsersContextProvider } from '../store/UsersContext.js';
import { DrawerContextProvider } from '../store/DrawerContext.js';
import { SubDrawerContextProvider } from '../store/SubDrawerContext';
import { ModalContextProvider } from '../store/ModalContext.js';
import { BuilderContextProvider } from '../store/BuilderContext';
import { DataGridContextProvider } from '../store/DataGridContext.js';
import { TableViewContextProvider } from '../store/TableViewContext.js';
import { LanguageContextProvider } from '../store/LanguageContext.jsx';
import { StatsContextProvider } from '../store/StatsContext.js';

const Providers = ({ children }) => {
  return (
    <ApiCacheProvider>
      <UsersContextProvider>
        <DrawerContextProvider>
          <SubDrawerContextProvider>
            <ModalContextProvider>
              <BuilderContextProvider>
                <DataGridContextProvider>
                  <TableViewContextProvider>
                    <LanguageContextProvider>
                      <StatsContextProvider>
                        {children}
                      </StatsContextProvider>
                    </LanguageContextProvider>
                  </TableViewContextProvider>
                </DataGridContextProvider>
              </BuilderContextProvider>
            </ModalContextProvider>
          </SubDrawerContextProvider>
        </DrawerContextProvider>
      </UsersContextProvider>
    </ApiCacheProvider>
  );
};

export default Providers;
